import { CustomerRoleDataType, UserType } from '~/types/user-info-types'

import { range } from '~/utils/helpers'

export const getBirthYearOptions = (): string[] => {
  const currYear = new Date().getFullYear()
  return range(100)
    .map((year: number) => currYear - year)
    .map(String)
}

export const gradeLevelData = (language: string): number[] => {
  return language === 'no' ? range(17).map((v) => v + 1) : [...range(10).map((v) => v + 1), 13, 16, 17]
}

export const getCustomerRolesData = (userType: UserType): CustomerRoleDataType => {
  return {
    type: userType,
    desc: `${userType}Description`,
  }
}

export const customerRoleDataByUserType = Object.values(UserType).map(getCustomerRolesData)

export const yearsInSchoolData = range(30).map(String)
